import { useQuery, UseQueryResult } from 'react-query'

import { getTreatment } from 'src/services/api/treatment'
import captureExceptionWithResponse from 'src/services/sentry'

import { TreatmentBundle } from '@customTypes/TreatmentBundle'
import { isEmpty } from 'src/utils/isEmpty'

const useTreatment: (
  clinicReferenceId: string,
  treatmentBundleTypeReferenceId?: string
) => UseQueryResult<TreatmentBundle> = (clinicReferenceId, treatmentBundleTypeReferenceId = '') => {
  const result = useQuery(
    ['treatment', clinicReferenceId, treatmentBundleTypeReferenceId],
    () => getTreatment(clinicReferenceId, treatmentBundleTypeReferenceId),
    {
      enabled: !isEmpty(treatmentBundleTypeReferenceId),
    }
  )

  if (result.isError) {
    captureExceptionWithResponse('Something went wrong while fetching treatment', result.error)
  }

  return result
}

export default useTreatment
